export default __webpack_public_path__ + "static/media/mlr-1-rMAX.1333559a.avif";